import React from 'react';
import { HeartIcon } from 'lucide-react';
interface LogoProps {
  className?: string;
  variant?: 'color' | 'light';
}

/**
 * Reconstruction typographique de la signature de la Ville : la vraie n'est pas
 * disponible en fichier vectoriel public. À remplacer par l'officielle.
 */
export function Logo({
  className = '',
  variant = 'color'
}: LogoProps) {
  const tone = variant === 'light' ? 'text-white' : 'text-ville-coral';
  return <span className={`inline-flex flex-col leading-none ${className}`} data-id="element-1457" data-mp="mtdwyr2wl3d2">
      <span className={`text-[10px] font-bold uppercase tracking-[0.22em] ${tone}`} data-id="element-1458" data-mp="rqw9erg4q0pt">Ville de</span>
      <span className="mt-1 flex items-end gap-1.5" data-id="element-1459" data-mp="dr4o05na9i1s">
        <span className={`font-display text-[32px] font-extrabold leading-none tracking-tight ${tone}`} data-id="element-1460" data-mp="duiplbo4hn86">
          Windsor
        </span>
        <HeartIcon className={`mb-1.5 h-3.5 w-3.5 shrink-0 fill-current ${tone}`} aria-hidden="true" data-id="element-1461" data-mp="2yi5fz93bnny9" />
      </span>
      <span className="sr-only" data-id="element-1462" data-mp="32ks1ks9egcn0">Ville de Windsor</span>
    </span>;
}